import { Outlet, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArenaSidebar } from 'modules/arena/shared/ArenaSidebar';
import { EASE_OUT } from 'shared/components/motion/tokens';

// Moldura fixa do painel da arena: a sidebar é montada uma única vez e fica parada;
// ao navegar, só a área de conteúdo troca (com um fade suave), sem "recarregar" o menu.
export function ArenaLayout() {
  const { pathname } = useLocation();

  return (
    <div className="flex flex-col md:flex-row">
      {/* A coluna estica até o fim da página (borda contínua); o menu dentro dela gruda no topo ao rolar. */}
      <div className="border-b border-border/60 bg-surface print:hidden md:w-56 md:flex-shrink-0 md:border-b-0 md:border-r">
        <div className="md:sticky md:top-0">
          <ArenaSidebar />
        </div>
      </div>

      <motion.div
        key={pathname}
        className="min-w-0 flex-1"
        initial={{ opacity: 0, y: 8, filter: 'blur(4px)' }}
        animate={{ opacity: 1, y: 0, filter: 'blur(0px)', transitionEnd: { filter: 'none' } }}
        transition={{ duration: 0.35, ease: EASE_OUT }}
      >
        <Outlet />
      </motion.div>
    </div>
  );
}
